import PropTypes from 'prop-types';
import { useRef, useState } from 'react';

//import { useLoadingSpinner } from 'contexts/loading-spinner/loading-spinner-context';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
  Box,
  ButtonBase,
  CardContent,
  ClickAwayListener,
  Grid,
  Paper,
  Popper,
  Stack,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';

// project import
import ProfileTab from './ProfileTab';
import SettingTab from './SettingTab';
import MainCard from 'components/MainCard';
import Transitions from 'components/@extended/Transitions';
import { MdPerson } from "react-icons/md";

import useAuth from 'hooks/useAuth';
import { ThemeMode } from 'config';

// assets
import {
  SettingOutlined,
  UserOutlined,
} from '@ant-design/icons';

// tab panel wrapper
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`profile-tabpanel-${index}`}
      aria-labelledby={`profile-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `profile-tab-${index}`,
    'aria-controls': `profile-tabpanel-${index}`,
  };
}

// ==============================|| HEADER CONTENT - PROFILE ||============================== //

const Profile = () => {
  const theme = useTheme();
  //const { showLoadingSpinner, hideLoadingSpinner } = useLoadingSpinner();


  const { logout, user } = useAuth(); 
  console.log('user', user);
  const handleLogout = () => {
    try {    
      //showLoadingSpinner();
      logout();
    } catch (err) {
      console.error(err);
      //hideLoadingSpinner();
    }
  };

  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const iconBackColorOpen =
    theme.palette.mode === ThemeMode.DARK ? 'background.default' : 'grey.100';

  return (
    <Box sx={{ flexShrink: 0, ml: 0.75}}>
      <ButtonBase
        sx={{
          p: 0.25,
          bgcolor: open ? iconBackColorOpen : 'transparent',
          borderRadius: 1,
          '&:hover': {
            bgcolor:
              theme.palette.mode === ThemeMode.DARK
                ? 'secondary.light'
                : 'secondary.lighter',
            color: theme.palette.primary.main,
          },
          '&:focus-visible': {
            outline: `2px solid ${theme.palette.secondary.dark}`,
            outlineOffset: 2,
          },
        }}
        aria-label='open profile'
        ref={anchorRef}
        aria-controls={open ? 'profile-grow' : undefined}
        aria-haspopup='true'
        onClick={handleToggle}
      >
        <Stack
          direction='row'
          spacing={1.25}
          alignItems='center'
          sx={{ p: 0.5 }}
        >
          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',

          }}>
            <MdPerson size={30} alt='Cuenta de usuario'/>
          </Box>

        </Stack>
      </ButtonBase>

      <Popper
        placement='bottom-end'
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 9],
              },
            },
          ],
        }}
      >
        {({ TransitionProps }) => (
          <Transitions
            type='grow'
            position='top-right'
            in={open}
            {...TransitionProps}
          >
            <Paper
              sx={{
                boxShadow: theme.customShadows.z1,
                width: 320,
                [theme.breakpoints.down('sm')]: {
                  width: 320,
                },
              }}
            >
              <ClickAwayListener onClickAway={handleClose}>
                <MainCard elevation={0} border={false} content={false}>
                  <CardContent sx={{ px: 2.5, pt: 3 }}>
                    <Grid
                      container
                      justifyContent='space-between'
                      alignItems='center'
                    >
                      <Grid item>
                        <Stack
                          direction='row'
                          spacing={1.25}
                          alignItems='center'
                        >
                          <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '40px',
                            height: '40px',
                            backgroundColor: theme.palette.primary.light,
                            borderRadius: '50%'
                          }}>
                            <MdPerson size={30} alt='Cuenta de usuario'/>
                          </Box>
                          <Stack>
                            <Typography variant='h6' sx={{ textTransform: 'capitalize' }}>
                              {user?.customVars?.empresa?.nombre || 'Sin nombre'}
                            </Typography>
                            <Typography variant='body2' color='textSecondary'>
                              Store ID: {process.env.REACT_APP_STORE_ID}
                            </Typography>
                            <Typography variant='body2' color='textSecondary'>
                              Usuario: {user?.id} | {user?.name}
                            </Typography>
                            <Typography variant='body2' color='textSecondary'>
                              Autorización: {user?.id_empresa} | {user?.role}
                            </Typography>
                          </Stack>
                        </Stack>
                      </Grid>
                    </Grid>
                  </CardContent>

                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                      variant='fullWidth'
                      value={value}
                      onChange={handleChange}
                      aria-label='profile tabs'
                    >
                      <Tab
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'center',
                          alignItems: 'center',
                          textTransform: 'capitalize',
                        }}
                        icon={
                          <UserOutlined
                            style={{ marginBottom: 0, marginRight: '10px' }}
                          />
                        }
                        label='Cuenta'
                        {...a11yProps(0)}
                      />
                      <Tab
                        disabled 
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'center',
                          alignItems: 'center',
                          textTransform: 'capitalize',
                        }}
                        icon={
                          <SettingOutlined
                            style={{ marginBottom: 0, marginRight: '10px' }}
                          />
                        }
                        label='Configuración'
                        {...a11yProps(1)}
                      />
                    </Tabs>
                  </Box>
                  <TabPanel value={value} index={0} dir={theme.direction}>
                    <ProfileTab handleLogout={handleLogout} />
                  </TabPanel>
                  <TabPanel value={value} index={1} dir={theme.direction}>
                    <SettingTab />
                  </TabPanel>
                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
    </Box>
  );
};

export default Profile;
